module.exports = __webpack_public_path__ + "c216723554808cada8dbb4afa63e934f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/wechat_active.png
// module id = 579
// module chunks = 0